import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-108bc77b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "cinema__card-progressbar"
}
const _hoisted_3 = { class: "cinema__card-progress-track" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "cinema__card-operations-menus"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["title"]
const _hoisted_10 = ["title"]
const _hoisted_11 = {
  key: 3,
  class: "cinema__card-season"
}
const _hoisted_12 = { class: "cinema__card-year" }

import { computed, ref } from 'vue'
import debounce from 'lodash/debounce'
import { 
  openCinemaSeries, 
  openPopMenu, 
  openPopCinemaFeedback, 
  openPopCinemaModify, 
  openCinemaDetail, 
  toast, 
} from '@remote/utils/dialog'
import { 
  useCinemaStore, 
  deleteNFO, 
  playNFO,
  computedNFOName,
  computedNFOPlayProgress,
  computedNFOIsTV,
  computedNFOIsOther,
} from '@remote/store/cinema'
import { isMobile } from '@remote/utils/base'
import fallback from '@shared/assets/img/cinema-fallback.png'
import { formatSize } from '@remote/utils'

interface IProps {
  /** 卡片数据类型: 播放历史 | 正常列表(默认) */
  type?: 'play_history' | 'view_list'
  nfo: API_NFO.NFO
  clickFrom?: string
  /** 海报宽高设置 */
  poster?: {
    /** 海报方向: 竖屏海报 | 横屏海报，默认为竖屏海报 */
    orientation?: 'portrait' | 'landscape'
  }
}


export default /*#__PURE__*/_defineComponent({
  props: {
    type: null,
    nfo: null,
    clickFrom: null,
    poster: null
  },
  setup(__props: any) {

const props = __props as {
  /** 卡片数据类型: 播放历史 | 正常列表(默认) */
  type?: 'play_history' | 'view_list'
  nfo: API_NFO.NFO
  clickFrom?: string
  /** 海报宽高设置 */
  poster?: {
    /** 海报方向: 竖屏海报 | 横屏海报，默认为竖屏海报 */
    orientation?: 'portrait' | 'landscape'
  }
}


const orientation = computed(() => props.poster?.orientation || 'portrait')
const isPlayHistory = props.type === 'play_history'

const cinemaStore = useCinemaStore()
const imgNodeRef = ref<HTMLImageElement | null>(null)
const nfoClass = computed(() => {
  const scrape_result = props.nfo.scrape_result
  return scrape_result?.class
})

const isOther = computed(() => computedNFOIsOther(props.nfo))
const isTVSeries = computed(() => computedNFOIsTV(props.nfo))

/**
 * 集数
 */
const episodeCount = computed(() => {
  if (isTVSeries.value) {
    const scrape_result = props.nfo.scrape_result
    if (!scrape_result) return 0
    const dramas = Array.isArray(scrape_result.dramas) ? scrape_result.dramas : []
    const episodeNums = scrape_result.episode_nums || 0
    return dramas.length || episodeNums
  }
  return 0
})

/**
 * 第X季。season字段不存在时返回‘’
 */
const season = computed(() => {
  const scrape_result = props.nfo.scrape_result
  if (isTVSeries.value && scrape_result?.season) {
    if (scrape_result?.season === '0') {
      return `共${episodeCount.value}集`
    }
    return `第${scrape_result.season}季·共${episodeCount.value}集`
  }
  return ''
})

const year = computed<string>(() => {
  return props.nfo.scrape_result?.year || ''
})

const fileSize = computed<string>(() => {
  return formatSize(props.nfo.video_info?.file_size) || ''
})

const thumb = computed(() => {
  const scrape_result = props.nfo.scrape_result
  if (orientation.value === 'landscape') {
    return scrape_result?.poster_horizontal ?? ''
  }
  return scrape_result?.poster_vertical ?? ''
})

const loadFallback = () => {
  if (imgNodeRef.value) {
    imgNodeRef.value.src = fallback
  }
}

const nfoName = computed(() => computedNFOName(props.nfo))

const cardTitle = computed(() => {
  if (props.type !== 'play_history') return nfoName.value
  if (!isTVSeries.value) return nfoName.value
  if (episodeCount.value) return `共${episodeCount.value}集·${nfoName.value}`
  return nfoName.value
})

const historySubTitle = computed(() => {
  if (props.type !== 'play_history') return year.value
  const scrape_result = props.nfo.scrape_result
  if (isTVSeries.value && scrape_result?.season) {
    if (scrape_result?.season === '0') {
      return year.value
    }
    return `第${scrape_result.season}季 | ${year.value}`
  }
  return year.value
})

const progress = computed(() => computedNFOPlayProgress(props.nfo))

const handleClick = debounce(() => {
  if (!isMobile() && !isOther.value) {
    return openCinemaDetail({
      nfo: props.nfo,
      from: props.from,
    })
  }

  if (isTVSeries.value) {
    if (props.type !== 'play_history') {
      console.log('openCinemaSeries', props.nfo)
      // 如果是连续剧，展示剧集列表
      openCinemaSeries({ nfo: props.nfo })
    } else {
      // 从最近观看播放，直接播放视频
      const videoName = props.nfo.last_record?.drama_name || nfoName.value
      playNFO(props.nfo,videoName, cinemaStore, true )
    }
  } else {
    // 如果不是连续剧，直接播放
    playNFO(props.nfo, nfoName.value, cinemaStore)
  }
}, 500, {
  leading: true,
  trailing: false,
})

const handleDelete = async () => {
  return deleteNFO(props.nfo, cinemaStore.deleteNFO, props.type === 'play_history')
}

const handleModify = () => {
  openPopCinemaModify({ nfo: props.nfo })
}

const handleFeedback = () => {
  openPopCinemaFeedback({ nfo: props.nfo })
}

const visibleOperationsMenus = ref(false)
const handleOnToggleVisibleOperationsMenus = () => {
  visibleOperationsMenus.value = !visibleOperationsMenus.value
}

const onLongPress = async () => {
  try {
    if (!isMobile() || isPlayHistory || isOther) return
    const menu = ['修改影片信息', '错误反馈', '删除视频']
    const res = await openPopMenu({
      options: menu,
    })
    if (res === '修改影片信息') {
      handleModify()
    }
    else if (res === '删除视频') {
      await handleDelete()
    } else if (res === '错误反馈') {
      openPopCinemaFeedback({ nfo: props.nfo })
    }
  } catch (error) {
    console.error(error)
    toast(error.message || error.error || '未知错误')
  }
}

return (_ctx: any,_cache: any) => {
  const _directive_longpress = _resolveDirective("longpress")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "cinema__card",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleClick) && _unref(handleClick)(...args))),
    onContextmenu: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (visibleOperationsMenus.value = false))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["cinema__card-poster", [`${_unref(orientation)}-poster`]])
    }, [
      _createElementVNode("img", {
        ref_key: "imgNodeRef",
        ref: imgNodeRef,
        src: _unref(thumb),
        onError: loadFallback
      }, null, 40, _hoisted_1),
      (__props.type === 'play_history')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "cinema__card-progress-stroke",
                style: _normalizeStyle({ width: `${_unref(progress)}%` })
              }, null, 4)
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (!isPlayHistory && !_unref(isOther))
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: "cinema__card-operations-more",
          onClick: _withModifiers(handleOnToggleVisibleOperationsMenus, ["stop"])
        }, null, 8, _hoisted_4))
      : _createCommentVNode("", true),
    (visibleOperationsMenus.value && !_unref(isOther))
      ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
          _createElementVNode("li", {
            onClick: _withModifiers(handleModify, ["stop"])
          }, " 修改影片信息 ", 8, _hoisted_6),
          _createElementVNode("li", {
            onClick: _withModifiers(handleFeedback, ["stop"])
          }, " 错误反馈 ", 8, _hoisted_7),
          _createElementVNode("li", {
            onClick: _withModifiers(handleDelete, ["stop"])
          }, " 删除视频 ", 8, _hoisted_8)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["cinema__card-name", { 'is-other': _unref(nfoClass) === 'other' }]),
      title: _unref(isOther) ? props.nfo.video_info?.real_path : ''
    }, _toDisplayString(_unref(cardTitle)), 11, _hoisted_9),
    (_unref(isTVSeries) && __props.type !== 'play_history')
      ? (_openBlock(), _createElementBlock("p", {
          key: 2,
          class: "cinema__card-season",
          title: _unref(season)
        }, _toDisplayString(_unref(season)), 9, _hoisted_10))
      : _createCommentVNode("", true),
    (_unref(isOther) && __props.type !== 'play_history')
      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_unref(fileSize)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(historySubTitle) || ' '), 1)
  ], 32)), [
    [_directive_longpress, onLongPress]
  ])
}
}

})